import { createAction, props } from '@ngrx/store';

import { DynamicTicketType } from '@app/services/dynamic-ticket-type.service';
import { RestProjectTypeModel } from '@main-application/management/pages/service-configuration/project-types/project-types.interface';
import { CreateDynamicTicketTypeModel } from '@shared/enums/ticket-type';
import { PmsCredentialModel } from '@shared/interfaces/pms-credential-model.interface';

/**
 * get System Config
 */
export const getServiceConfig = createAction('[System Config] get System Config');
export const getServiceConfigSuccess = createAction(
  '[System Config] get System Config success',
  props<{ serviceConfig: PmsCredentialModel[] }>()
);
export const getServiceConfigError = createAction('[System Config] get System Config error');

export const setServiceSectionExpanded = createAction(
  '[System Config] setSystemSectionExpanded',
  props<{
    section: 'Statuses' | 'Resident' | 'Triggers' | 'ticketTypes' | 'projectTypes' | 'appointmentTypes';
    state: boolean;
  }>()
);

export const loadDynamicTickets = createAction('[System Config] Load dynamic tickets');

export const loadDynamicTicketsSuccess = createAction(
  '[System Config] Load dynamic tickets success',
  props<{ items: DynamicTicketType[] }>()
);

export const loadDynamicTicketsFailed = createAction('[System Config] Load dynamic tickets failed');

export const dynamicTicketsLoading = createAction('[System Config] Dynamic tickets loading start');
export const dynamicTicketsLoadedSuccess = createAction('[System Config] Dynamic tickets loaded success');

export const clearDynamicTickets = createAction('[System Config] Clear dynamic tickets');
export const openDynamicTicketCreationModal = createAction(
  '[System Config] Open dynamic ticket creation modal',
  props<{ create: number }>()
);

export const createDynamicTicket = createAction(
  '[System Config] Create dynamic ticket',
  props<{ model: CreateDynamicTicketTypeModel }>()
);

export const createDynamicTicketSuccess = createAction(
  '[System Config] Dynamic ticket create success',
  props<DynamicTicketType>()
);
export const createDynamicTicketError = createAction('[System Config] create dynamic ticket error');

export const editDynamicTicket = createAction(
  '[System Config] Edit dynamic ticket',
  props<{ model: CreateDynamicTicketTypeModel; id: number }>()
);

export const editDynamicTicketSuccess = createAction(
  '[System Config] Edit ticket create success',
  props<DynamicTicketType>()
);
export const editDynamicTicketError = createAction('[System Config] Edit dynamic ticket error');

export const deleteDynamicTicket = createAction('[System Config] delete dynamic ticket', props<{ id: number }>());
export const deleteDynamicTicketSuccess = createAction(
  '[System Config] delete dynamic ticket success',
  props<{ id: number }>()
);
export const deleteDynamicTicketError = createAction('[System Config] delete dynamic ticket error');

export const loadProjectTypes = createAction('[System Config] Load project types');

export const loadProjectTypesSuccess = createAction(
  '[System Config] Load project types success',
  props<{ items: RestProjectTypeModel[] }>()
);

export const loadProjectTypesFailed = createAction('[System Config] Load project types failed');

export const openProjectTypeCreationModal = createAction(
  '[System Config] Open project type creation modal',
  props<{ create: number }>()
);

export const createProjectType = createAction('[System Config] Create project type', props<{ name: string }>());

export const createProjectTypeSuccess = createAction(
  '[System Config] Project type create success',
  props<RestProjectTypeModel>()
);
export const createProjectTypeError = createAction('[System Config] create project type error');

export const editProjectType = createAction('[System Config] Edit project type', props<{ name: string; id: number }>());

export const editProjectTypesSuccess = createAction(
  '[System Config] Edit project type success',
  props<RestProjectTypeModel>()
);
export const editProjectTypesError = createAction('[System Config] Edit project type error');

export const deleteProjectType = createAction('[System Config] Delete project type', props<{ id: number }>());
export const deleteProjectTypeSuccess = createAction(
  '[System Config] delete project type success',
  props<{ id: number }>()
);
export const deleteProjectTypeError = createAction('[System Config] delete project type error');

export const clearProjectTypes = createAction('[System Config] Clear project types');
export const clearCreatedNewProject = createAction('[System Config] Clear created new project');
